import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Board from "./components/Board";
import TaskModal from "./components/TaskModel";
import tasksData from "./data/tasks.json";

function App() {
  const [tasks, setTasks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editTask, setEditTask] = useState(null);
  const [dateFilter, setDateFilter] = useState("All");
  const [sortType, setSortType] = useState("created-new");

  // Load tasks
  useEffect(() => {
    const saved = localStorage.getItem("tasks");
    if (saved) setTasks(JSON.parse(saved));
    else {
      setTasks(tasksData);
      localStorage.setItem("tasks", JSON.stringify(tasksData));
    }
  }, []);

  // Save tasks
  useEffect(() => {
    localStorage.setItem("tasks", JSON.stringify(tasks));
  }, [tasks]);

  // Add / Update task
  const saveTask = (task) => {
    if (task.id) {
      setTasks(tasks.map(t => t.id === task.id ? task : t));
    } else {
      setTasks([
        ...tasks,
        { ...task, id: Date.now(), createdAt: new Date().toISOString() }
      ]);
    }
  };

  // Filter by created date
  const filteredTasks = tasks.filter(task => {
    if (dateFilter === "All") return true;

    const created = new Date(task.createdAt);
    const today = new Date();

    if (dateFilter === "Today")
      return created.toDateString() === today.toDateString();

    if (dateFilter === "Last7")
      return (today - created) / (1000 * 60 * 60 * 24) <= 7;

    return true;
  });

  // Sort
  const sortedTasks = [...filteredTasks].sort((a, b) => {
    if (sortType === "created-new")
      return new Date(b.createdAt) - new Date(a.createdAt);

    if (sortType === "created-old")
      return new Date(a.createdAt) - new Date(b.createdAt);

    if (sortType === "due")
      return new Date(a.dueDate || "2099-01-01") -
             new Date(b.dueDate || "2099-01-01");

    return 0;
  });

  return (
    <>
      <Navbar onAdd={() => setShowModal(true)} />

      {/* FILTER & SORT */}
      <div style={{ padding: "10px" }}>
        <select onChange={(e) => setDateFilter(e.target.value)}>
          <option value="All">All Dates</option>
          <option value="Today">Today</option>
          <option value="Last7">Last 7 Days</option>
        </select>

        <select onChange={(e) => setSortType(e.target.value)} style={{ marginLeft: "10px" }}>
          <option value="created-new">Newest Created</option>
          <option value="created-old">Oldest Created</option>
          <option value="due">Closest Due Date</option>
        </select>
      </div>

      {/* BOARDS */}
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <Board title="To-Do" tasks={sortedTasks} setTasks={setTasks} onEdit={setEditTask} />
        <Board title="In-Progress" tasks={sortedTasks} setTasks={setTasks} onEdit={setEditTask} />
        <Board title="Completed" tasks={sortedTasks} setTasks={setTasks} onEdit={setEditTask} />
      </div>

      {(showModal || editTask) && (
        <TaskModal
          editTask={editTask}
          onSave={saveTask}
          onClose={() => { setShowModal(false); setEditTask(null); }}
        />
      )}
    </>
  );
}

export default App;